import './Contact.css';

const Contact = () => {
    return (
        <div className="contact-page">

            {/* SECTION 1: CONTACT INFO & GET IN TOUCH FORM */}
            <section className="contact-section">
                <div className="contact-container">

                    {/* LEFT COLUMN */}
                    <div className="contact-left">
                        {/* LOCATION CARD */}
                        <div className="info-card">
                            <div className="info-icon">📍</div>
                            <h4>Our Location</h4>
                            <p>
                                Mohan Kumar Complex,<br />
                                Ponnaegoundenpudur,<br />
                                Coimbatore
                            </p>
                            <p>
                                10/395 7th Street Nachatra<br />
                                Garden Oraikalpalayam,<br />
                                Coimbatore
                            </p>
                        </div>

                        {/* PHONE CARD */}
                        <div className="info-card">
                            <div className="info-icon">📞</div>
                            <h4>Phone Number</h4>
                            <p>95148 96744</p>
                            <p>0422 - 7140842</p>
                        </div>

                        {/* EMAIL CARD */}
                        <div className="info-card">
                            <div className="info-icon">✉️</div>
                            <h4>Our Email</h4>
                            <p>business@JeevanRealty.com</p>
                        </div>
                    </div>

                    {/* RIGHT COLUMN */}
                    <div className="contact-right">
                        <h2>Get In Touch</h2>

                        <form className="contact-form">
                            <div className="form-group">
                                <label>Your Name <span>*</span></label>
                                <input type="text" placeholder="Enter your name" required />
                            </div>

                            <div className="form-group">
                                <label>Your Email <span>*</span></label>
                                <input type="email" placeholder="Enter your email" required />
                            </div>

                            <div className="form-group">
                                <label>Your Subject <span>*</span></label>
                                <input type="text" placeholder="Enter your subject" required />
                            </div>

                            <div className="form-group">
                                <label>Your Phone <span>*</span></label>
                                <input type="text" placeholder="Enter your phone number" required />
                            </div>

                            <div className="form-group">
                                <label>Your Message</label>
                                <textarea rows={4} placeholder="Your message here"></textarea>
                            </div>

                            <div className="form-consent">
                                <input type="checkbox" id="terms" />
                                <label htmlFor="terms">
                                    By clicking Submit, you agree to our Terms.
                                    <br />
                                    View Our TOS and Privacy Policy
                                </label>
                            </div>

                            <button type="submit" className="submit-btn">
                                Send message
                            </button>
                        </form>
                    </div>

                </div>
            </section>


            {/* SECTION 2: MAP & ENQUIRY FORM */}
            <section className="map-contact-section">
                <div className="map-contact-container">

                    {/* LEFT SIDE : ADDRESS + MAP */}
                    <div className="map-contact-left">
                        <h2>Where you can find us:</h2>

                        <div className="contact-details">
                            <p>
                                Lorem, ipsum dolor.<br />
                                Lorem, ipsum, Coimbatore – 741852
                            </p>
                            <p className="phone">+91 7418529635</p>
                            <p className="email">jeevanrealty@gmail.com</p>
                        </div>

                        {/* MAP */}
                        <div className="contact-map">
                            <iframe
                                src="https://www.google.com/maps?q=11.0600518,77.0328845&t=k&z=17&output=embed"
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Map"
                            >
                            </iframe>
                        </div>
                    </div>

                    {/* RIGHT SIDE : FORM */}
                    <div className="map-contact-right">
                        <h2>Place Your Enquiry!</h2>
                        <span className="form-underline"></span>

                        <form className="enquiry-form">
                            <div className="form-group">
                                <label>Name <span>*</span></label>
                                <input type="text" required />
                            </div>

                            <div className="form-group">
                                <label>Phone <span>*</span></label>
                                <input type="tel" required />
                            </div>

                            <div className="form-group">
                                <label>Email <span>*</span></label>
                                <input type="email" required />
                            </div>

                            <div className="form-group">
                                <label>Service Required? <span>*</span></label>
                                <select required defaultValue="">
                                    <option value="" disabled>-Please Select a Service-</option>
                                    <option>Web Site</option>
                                    <option>Web Application</option>
                                    <option>Investment</option>
                                    <option>Consultation</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label>Tell us more</label>
                                <textarea rows={4}></textarea>
                            </div>

                            <button type="submit" className="submit-btn">Submit</button>
                        </form>
                    </div>

                </div>
            </section>

        </div>
    );
};

export default Contact;
